var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShadcraft = function SvgShadcraft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 26 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M.776 12.526C.776 5.718 6.294.199 13.102.199s12.326 5.52 12.326 12.327-5.518 12.326-12.326 12.326S.776 19.333.776 12.526"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M14.8 14.178a.913.913 0 1 1 1.296 1.286l-1.789 1.804-.07.063a.913.913 0 0 1-1.29-1.279l.063-.07zm-4.52-1.736a.914.914 0 0 1 1.292 1.292L8.035 17.27l-.07.062a.913.913 0 0 1-1.284-1.284l.063-.07zm6.616-.462a.914.914 0 0 1 1.292 1.29l-.035.035-.07.064a.913.913 0 0 1-1.284-1.285l.063-.07zm-3.004-3.027a.913.913 0 0 1 1.277 1.305l-1.347 1.319-.07.061a.913.913 0 0 1-1.27-1.298l.063-.07zm2.105-2.235a.913.913 0 0 1 1.29 1.291l-.035.036-.07.063a.913.913 0 0 1-1.284-1.284l.063-.07z"
  })));
};
export default SvgShadcraft;